<script>
    import { navigateTo } from 'svelte-router-spa'
    import { visitCompany, visitAddress } from '../../../store.js'
    let corpName, corpAddress

    function nxt() {
        visitCompany.set(corpName)
        visitAddress.set(corpAddress)
        navigateTo('symptom')
    }
</script>

<main>
    <div class="body">
        <h1>Please fill in your company's details</h1>
        <p>Pakilagay ang sumusunod na detalye ukol sa inyong kumpanya</p>
        
        <label for="corpName">Company Name</label>
        <input type="text" bind:value={corpName} name="corpName">

        <label for="corpAddress">Company Address</label>
        <textarea bind:value={corpAddress} name="corpAddress" rows="4"></textarea>

        {#if corpName && corpAddress}
        <a class="btn btn-primary" on:click={nxt}>Next</a>
        {/if}
    </div>
</main>